<!-- COUNT INCORRECT SCREEN -->
<div class="container pt-5 min-vh-100 d-flex" style="max-width: 450px; position: relative;">

  <!-- Header -->
  <div class="container pt-4">
    <div class="d-flex justify-content-between align-items-center mb-4">
      <h3 class="fw-bold text-dark mb-0">Count Incorrect</h3>
      <i class="bi bi-x-lg fs-4 text-secondary fw-bold cursor-pointer" (click)="cancel()"></i>
    </div>

    <p class="text-secondary fw-bold mb-2">Enter Amount Counted</p>

    <!-- Input Display -->
    <div class="bg-white border rounded-3 px-3 py-2 mb-4 d-flex justify-content-between align-items-center shadow-sm"
      style="height: 70px; border-color: #dee2e6 !important;">
      <span class="fw-bold fs-5" [ngClass]="{'text-danger': amountDifference !== 0, 'text-success': amountDifference === 0}">
        {{ amountDifference > 0 ? '+' : '' }}{{ amountDifference | currency:'EUR':'symbol':'1.2-2' }}
      </span>
      <span class="fw-bold fs-1 text-dark">{{ countedAmount | currency:'EUR':'symbol':'1.2-2' }}</span>
    </div>

    <!-- Keypad -->
    <div class="row g-2 mb-4">
      <div class="col-4" *ngFor="let num of [1,2,3,4,5,6,7,8,9]">
        <button class="btn btn-primary w-100 fs-2 fw-bold shadow-sm" style="height: 70px; border-radius: 10px;"
          (click)="appendCount(num)">{{ num }}</button>
      </div>

      <!-- Row 4: Backspace and 0 -->
      <div class="col-4 d-flex justify-content-center align-items-center pt-2">
        <!-- Backspace Custom Design -->
        <button class="btn bg-white text-primary fs-4 p-0 d-flex align-items-center justify-content-center"
          (click)="clearCountLastDigit()">
          <svg width="56" height="40" viewBox="0 0 36 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M26.7062 8.70625L23.4125 12L26.7062 15.2938C27.1 15.6813 27.1 16.3187 26.7062 16.7062C26.3187 17.1 25.6813 17.1 25.2938 16.7062L21.9438 13.4125L18.7062 16.7062C18.3187 17.1 17.6813 17.1 17.2938 16.7062C16.9 16.3187 16.9 15.6813 17.2938 15.2938L20.5875 12L17.2938 8.70625C16.9 8.31875 16.9 7.68125 17.2938 7.29375C17.6813 6.9 18.3187 6.9 18.7062 7.29375L21.9438 10.5875L25.2938 7.29375C25.6813 6.9 26.3187 6.9 26.7062 7.29375C27.1 7.68125 27.1 8.31875 26.7062 8.70625ZM32 0C34.2062 0 36 1.79063 36 4V20C36 22.2062 34.2062 24 32 24H12.8313C11.7688 24 10.75 23.5812 10 22.8312L0.58575 13.4125C0.210687 13.0375 0 12.5312 0 12C0 11.4688 0.21075 10.9625 0.58575 10.5875L10 1.17188C10.75 0.42125 11.7688 0 12.8313 0H32ZM34 4C34 2.89375 33.1063 2 32 2H12.8313C12.3 2 11.7875 2.21063 11.4125 2.5875L1.94375 12L11.4125 21.4125C11.7875 21.7875 12.3 22 12.8313 22H32C33.1063 22 34 21.1063 34 20V4Z"
              fill="#3D45E0" />
          </svg>
        </button>
      </div>
      <div class="col-8">
        <button class="btn btn-primary w-100 fs-2 fw-bold shadow-sm" style="height: 70px; border-radius: 10px;"
          (click)="appendCount(0)">0</button>
      </div>
    </div>

    <!-- Enter Button -->
    <div class="mt-3">
      <button class="btn btn-primary w-100 py-3 rounded-3 fw-bold fs-5 custom-btn-blue shadow-sm"
        (click)="confirm()">Enter</button>
    </div>
  </div>
</div>

